import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("elle_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Ensure we only trigger the session-expired redirect once per page load —
// if several requests are in flight when the token dies, we don't want a
// stampede of redirects.
let _redirecting = false;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !_redirecting) {
      const here = window.location.pathname;
      const reqUrl = err?.config?.url || "";
      // 401 on /auth/login is just "wrong password" — do not log out.
      const isAuthCall = reqUrl.includes("/auth/login") ||
                         reqUrl.includes("/auth/setup");
      if (!isAuthCall && here !== "/login" && here !== "/setup") {
        _redirecting = true;
        localStorage.removeItem("elle_token");
        try {
          toast.error("Your session expired. Sign back in — any open draft has been saved locally.",
                      { duration: 6000 });
        } catch {}
        // Small delay so the toast is visible before the hard redirect.
        setTimeout(() => {
          window.location.href = "/login?reason=expired";
        }, 400);
      }
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => {
  if (t) localStorage.setItem("elle_token", t);
  else localStorage.removeItem("elle_token");
};

export const getToken = () => localStorage.getItem("elle_token");
